﻿import { store } from '@redux/store';
import GoogleAdsEvent from 'dataTransferObjects/googleAdsEvent';
import GoogleAdsEventType from 'enums/googleAdsEventType';
import getTrackingCommonProperties from 'features/trackingProperties';

/**
 * The function to get the enhanced conversion properties to Google ads event.
 * Read more at https://support.google.com/google-ads/answer/9888656?hl=en
 * @returns object containing the common properties for enhanced conversion.
 */
const getEnhancedConversionProperties = () => {
  const state = store.getState();
  const commonProperties = getTrackingCommonProperties(state);

  const enhancedConversionProperties = {
    email: commonProperties.email,
    phone_number: commonProperties.phone,
  };

  return enhancedConversionProperties;
};

const createTrackEvent = (eventName) => {
  const data = getEnhancedConversionProperties();

  return () => new GoogleAdsEvent(eventName, data);
};

/**
 * The getGoogleAdsEvent function returns a GoogleAdsEvent object.
 *
 * @return An GoogleAnalytics4Event object
 */
const getGoogleAdsEvent = (eventType, eventName) => {
  if (eventType === GoogleAdsEventType.Event) {
    return createTrackEvent(eventName);
  }

  return null;
};

export default getGoogleAdsEvent;
